import "./../../bindings/bao-tabs";
import "./../../bindings/bao-searcher";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import SearchPaging from "./../../factories/search-paging";
import BaoDialog from "./../../factories/bao-dialog";
import TabPage from "./../../factories/tab-page";
import TabController from "./../../factories/tab-controller";
import Device4Assignment from "./device4-assignment";
import TranslateDialog from "./../../factories/translate-dialog";
function Device4ViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.TabPage = tabPage;
    self.TabViewModel = new TabController(false);
    self.FormName = ko.observable();
    self.Device4Name = ko.observable();
    self.Device4Name1 = ko.observable();
    self.Device4Name2 = ko.observable();
    self.Device4Name3 = ko.observable();
    self.Device4Name4 = ko.observable();
    self.Device4Name5 = ko.observable();
    self.Description = ko.observable();
    self.Description1 = ko.observable();
    self.Description2 = ko.observable();
    self.Description3 = ko.observable();
    self.Description4 = ko.observable();
    self.Description5 = ko.observable();
    self.Translate = function () {
        var translateDialog = new TranslateDialog(self.Device4Name1, self.Device4Name2, self.Device4Name3, self.Device4Name4, self.Device4Name5);
        translateDialog.Open().then(function () {
        });
    };
    self.Device4NameComputed = ko.computed(function () {
        //nur für "suscriptions"
        if (self != undefined) {
            self.Device4Name1();
            self.Device4Name2();
            self.Device4Name3();
            self.Device4Name4();
            self.Device4Name5();
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    self.Device4Name(self.Device4Name1());
                    break;
                case 2:
                    self.Device4Name(self.Device4Name2());
                    break;
                case 3:
                    self.Device4Name(self.Device4Name3());
                    break;
                case 4:
                    self.Device4Name(self.Device4Name4());
                    break;
                case 5:
                    self.Device4Name(self.Device4Name5());
                    break;
            }
        }
    });
    self.Device4Name.subscribe(function () {
        switch (Bao.Session.Language.LanguageIndex()) {
            case 1:
                self.Device4Name1(self.Device4Name());
                break;
            case 2:
                self.Device4Name2(self.Device4Name());
                break;
            case 3:
                self.Device4Name3(self.Device4Name());
                break;
            case 4:
                self.Device4Name4(self.Device4Name());
                break;
            case 5:
                self.Device4Name5(self.Device4Name());
                break;
        }
    });
    self.Description.subscribe(function (v) {
        switch (Bao.Session.Language.LanguageIndex()) {
            case 2:
                self.Description2(v);
                break;
            case 3:
                self.Description3(v);
                break;
            case 4:
                self.Description4(v);
                break;
            case 5:
                self.Description5(v);
                break;
            default:
                self.Description1(v);
                break;
        }
    });
    self.loaded = function () {
        this.InitPaging();
        this.TabPage.DirtyFlag.reset();
        this.TabPage.IsLoading(false);
        this.Focus();
        var newTab = new TabPage(null);
        newTab.Url("MasterData/Device4/AssignmentTab");
        newTab.AutoSelect = true;
        newTab.IsClosable(false);
        newTab.PreLoad(true);
        newTab.Visible(true);
        newTab.ViewModel(new Device4Assignment(self.TabPage, self));
        newTab.ViewModel().Refresh();
        newTab["Bao"] = Bao;
        self.TabViewModel.AddTab(newTab);
    };
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.Device4Name())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    // Erweiterung des Models zum Server aufgrund array-dirtyFlag-Problem
    self.ExtendModelForSave = function (model) {
    };
    var baseRefresh = self.PerformRefresh;
    self.PerformRefresh = function () {
        var def = $.Deferred();
        return baseRefresh.call(self).then(function () {
            return Bao.post("Device4/ResetAssignment", JSON.stringify({ sessionTabId: self.SessionTabId() })).then(function () {
                self.TabViewModel.RefreshTabs().then(def.resolve);
                return def.promise();
            });
        });
    };
}
Bao.inherit(Device4ViewModel, SearchPaging);
Device4ViewModel.prototype.PrimaryKey = "Device4Id";
Device4ViewModel.prototype.RefreshUrl = "MasterData/Device4/Get";
Device4ViewModel.prototype.SaveUrl = "MasterData/Device4/Save";
Device4ViewModel.prototype.DeleteUrl = "MasterData/Device4/Delete";
Device4ViewModel.prototype.IsInUseUrl = "MasterData/Device4/IsInUse";
Device4ViewModel.prototype.PermissionForward = "Device4Forward";
Device4ViewModel.prototype.PermissionBackward = "Device4Backward";
Device4ViewModel.prototype.PermissionSave = "Device4Save";
Device4ViewModel.prototype.PermissionRefresh = "Device4Refresh";
Device4ViewModel.prototype.PermissionDelete = "Device4Delete";
export default Device4ViewModel;